import { render, staticRenderFns } from "./CaseReporting.vue?vue&type=template&id=4ca9e9a3&"
import script from "./CaseReporting.vue?vue&type=script&lang=js&"
export * from "./CaseReporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports